import { useState } from "react";
import { useParams } from "react-router-dom";
import LoadingScreen from "@/components/LoadingScreen";

export default function SampleReportViewerPage() {
  const { module } = useParams();
  const [loading, setLoading] = useState(true);

  const reportMap = {
    "assembly": "/sample-reports/assembly.html",
    "assembly-screening": "/sample-reports/assembly-screening.html",
    "chipseq": "/sample-reports/chipseq.html",
    "differential-expression": "/sample-reports/differential-expression.html",
    "eukaryotes-gene-prediction": "/sample-reports/eukaryotes-gene-prediction.html",
    "eukaryotes-genome-finishing": "/sample-reports/eukaryotes-genome-finishing.html",
    "eukaryotics-draft-assembly": "/sample-reports/eukaryotics-draft-assembly.html",
    "exome": "/sample-reports/exome.html",
    "gene-annotation": "/sample-reports/gene-annotation.html",
    "gene-annotation-transcriptome": "/sample-reports/gene-annotation-transcriptome.html",
    "metagenome": "/sample-reports/metagenome.html",
    "phylogeny": "/sample-reports/phylogeny.html",
    "prokaryotes-gene-prediction": "/sample-reports/prokaryotes-gene-prediction.html",
    "prokaryotes-genome-finishing": "/sample-reports/prokaryotes-genome-finishing.html",
    "prokaryotics-draft-assembly": "/sample-reports/prokaryotics-draft-assembly.html",
    "raw-data-qc": "/sample-reports/raw-data-qc.html",
    "repeat-annotation": "/sample-reports/repeat-annotation.html",
    "transcriptome-model": "/sample-reports/transcriptome-model.html",
    "tRNA-scan": "/sample-reports/tRNA-scan.html",
    "variant-analysis": "/sample-reports/variant-analysis.html",
  };

  const reportPath = reportMap[module];

  if (!reportPath) {
    return (
      <div className="flex h-[calc(100vh-90px)] items-center justify-center text-gray-500">
        Sample report not found.
      </div>
    );
  }

  return (
    <div className="relative h-[calc(100vh-90px)] overflow-hidden rounded-xl border border-gray-200 bg-white">
      {loading && (
        <div className="absolute inset-0 z-10 bg-white">
          <LoadingScreen />
        </div>
      )}

      <iframe
        src={reportPath}
        title="Sample Report"
        className="h-full w-full border-0"
        onLoad={() => setLoading(false)}
      />
    </div>
  );
}